import Actions from './action';

export const welcomeInitState = {
	isOpportunityLoading: false,
	isCompAgreementLoading: false,
	opportunityData: [],
	currentStatus: 2,
	stepLabels: [
		{ title: 'Company Info', count: 1, pageIndex: 0, route: `/user/companyinfo/${localStorage.getItem('companyId')}`, disable: false },
		{ title: 'Contact Info', count: 2, pageIndex: 1, route: '/user/contactinfo/1', disable: false },
		{ title: 'Signature', count: 3, pageIndex: 3, route: '/user/signature/1', disable: false },
	],
	compAgmnt: []
};

const opportunityReducer = (state = welcomeInitState, action) => {
	switch (action.type) {
		case Actions.types.GET_OPPORTUNITY_DATA_START: {
			console.log("helo")
			return {
				...state,
				isOpportunityLoading: true,
			};
		}
		case Actions.types.GET_OPPORTUNITY_DATA_SUCCESS: {
			console.log("SUCCESS", action.res.data)
			return {
				...state,
				isOpportunityLoading: false,
				opportunityData: action.res.data,
			};
		}
		case Actions.types.GET_OPPORTUNITY_DATA_ERROR: {
			return {
				...state,
				isOpportunityLoading: false,
			};
		}
		case Actions.types.GET_COMPANY_AGREEMENT_START: {
			return {
				...state,
				isCompAgreementLoading: true,
			};
		}
		case Actions.types.GET_COMPANY_AGREEMENT_SUCCESS: {
			return {
				...state,
				isCompAgreementLoading: false,
				compAgmnt: action.res
			};
		}
		case Actions.types.GET_COMPANY_AGREEMENT_ERROR: {
			return {
				...state,
				isCompAgreementLoading: false,
			};
		}

		default:
			return state;
	}
};

export default opportunityReducer;
